'use es6';

import { uniqueId, flatten } from 'underscore';
import { MENU_TREE_LOAD, MENU_TREE_MOVE_NODE, MENU_TREE_ADD_NODE, MENU_TREE_ADD_CHILD, MENU_TREE_ADD_NODE_TO_BOTTOM, MENU_TREE_CLONE_NODE, MENU_TREE_DELETE_NODE, MENU_TREE_DELETE_TREE } from 'simple-menus-core/actions/ActionTypes';
import TreeNode from 'simple-menus-core/models/TreeNode';
import MenuNode from 'simple-menus-core/models/MenuNode';
import MenuNodeTypes from 'simple-menus-core/enums/MenuNodeTypes';
import { getMenuNode } from 'simple-menus-core/selectors/menuNode';
import { getMenuTreeNode, getMenuTree } from 'simple-menus-core/selectors/menuTree';
import DropPositions from 'simple-menus-core/enums/DropPositions';
import { getChildIds } from 'simple-menus-core/utils/menuTree';
function getUniqueId() {
  return uniqueId('menu_node_');
}
export function loadMenuTree(tree = [], menuId) {
  const nodesById = {};
  const generateMinimalTree = node => {
    const id = getUniqueId();
    const children = node.children ? node.children.map(generateMinimalTree) : [];
    nodesById[id] = new MenuNode(node);
    return new TreeNode({
      id,
      children
    });
  };
  const minimalTree = tree.map(generateMinimalTree);
  return {
    type: MENU_TREE_LOAD,
    tree: minimalTree,
    menuId,
    nodesById
  };
}
export function moveNode(nodeId, targetId, targetParentId, position, menuId) {
  return {
    type: MENU_TREE_MOVE_NODE,
    nodeId,
    targetId,
    targetParentId,
    position,
    menuId
  };
}
export function addChildNode(parentId, menuId, node = {
  type: MenuNodeTypes.PAGE_LINK
}) {
  const nodeId = getUniqueId();
  const menuNode = new MenuNode(node);
  const treeNode = new TreeNode({
    id: nodeId
  });
  return {
    type: MENU_TREE_ADD_CHILD,
    nodeId,
    parentId,
    menuNode,
    treeNode,
    menuId
  };
}
export function addNode(menuId, parentId, siblingId, node = {
  type: MenuNodeTypes.PAGE_LINK
}, position = DropPositions.BOTTOM) {
  const nodeId = getUniqueId();
  const menuNode = new MenuNode(node);
  const treeNode = new TreeNode({
    id: nodeId
  });
  return {
    type: MENU_TREE_ADD_NODE,
    nodeId,
    parentId,
    siblingId,
    menuNode,
    treeNode,
    position,
    menuId
  };
}
export function addNodeToBottom(menuId, node = {
  type: MenuNodeTypes.PAGE_LINK
}) {
  const nodeId = getUniqueId();
  const menuNode = new MenuNode(node);
  const treeNode = new TreeNode({
    id: nodeId
  });
  return {
    type: MENU_TREE_ADD_NODE_TO_BOTTOM,
    nodeId,
    menuNode,
    treeNode,
    menuId
  };
}
export function cloneNode(parentId, nodeId, menuId) {
  return (dispatch, getState) => {
    const state = getState();
    const menuNode = getMenuNode(state, {
      id: nodeId
    });
    const menuTreeNode = getMenuTreeNode(state, {
      id: nodeId,
      menuId
    });
    const newId = getUniqueId();
    const nodesById = {
      [newId]: menuNode
    };
    const generateMinimalTree = node => {
      const id = getUniqueId();
      const children = node.children ? node.children.map(generateMinimalTree) : [];
      nodesById[id] = getMenuNode(state, {
        id: node.id
      });
      return new TreeNode({
        id,
        children
      });
    };
    const children = menuTreeNode.children.map(generateMinimalTree);
    const treeNode = new TreeNode({
      id: newId,
      children
    });
    dispatch({
      type: MENU_TREE_CLONE_NODE,
      parentId,
      siblingId: nodeId,
      nodesById,
      treeNode,
      menuId
    });
  };
}
export function deleteNode(id, menuId) {
  return (dispatch, getState) => {
    const treeNode = getMenuTreeNode(getState(), {
      id,
      menuId
    });
    const childIds = treeNode.children.map(getChildIds);
    dispatch({
      type: MENU_TREE_DELETE_NODE,
      id,
      childIds,
      menuId
    });
  };
}
export function deleteTree(menuId) {
  return (dispatch, getState) => {
    const tree = getMenuTree(getState(), {
      menuId
    });
    const nodeIds = flatten(tree.map(getChildIds));
    dispatch({
      type: MENU_TREE_DELETE_TREE,
      menuId,
      nodeIds
    });
  };
}